// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__QB3Jc","loading":"Spinner_loading__XfwCl"};